// extracted by mini-css-extract-plugin
export default {"pattern":"Layout_pattern__LkVpH","fixedImage":"Layout_fixedImage__bbNdo","chatStyle":"Layout_chatStyle__ElSJP"};